import { Card, Group, Stack, Text } from '@mantine/core';
import InfoBadge from '@/app/components/shared/InfoBadge';
import { ReactNode } from 'react';
import { IconButton } from '@/app/components/shared/IconButton';
import TrashIcon from '@/icons/trash.svg';
import { AssetTagBadge } from '@/app/assets/details/atoms/AssetTagBadge';
import { NewTag } from './NewTag';
import { mainTypes } from '@/utils/fileUtils';
import { truncateStringInMiddle } from '@/utils/truncateString';

export type RawModelView = {
  path?: string;
  name: string;
  extension: string;
  size: number;
  tags?: string[];
  addTag: (tag: string) => void;
  removeTag: (tag: string) => void;
};

type RawModelProps = {
  onRemoveAsset: () => void;
  validationError?: ReactNode;
  isUploadPending: boolean;
} & RawModelView;

export default function RawModel({
  name,
  extension,
  size,
  onRemoveAsset,
  validationError,
  isUploadPending,
  tags,
  addTag,
  removeTag,
}: RawModelProps) {
  return (
    <Card shadow='md' padding='md'>
      <Stack align='center'>
        <Group wrap='nowrap' justify='space-between' w='100%'>
          <Group gap='xs' flex='3 1'>
            <Text>{truncateStringInMiddle(name, { breakPoint: 15, maxLength: 30 })}</Text>
            {mainTypes.includes(extension.toLowerCase()) && (
              <>
                {tags?.map((tag) => (
                  <AssetTagBadge key={tag} iconClick={() => removeTag(tag)}>
                    {tag}
                  </AssetTagBadge>
                ))}
                <NewTag tags={tags} onAddTag={addTag} />
              </>
            )}
          </Group>
          <Group flex='2 1' wrap='nowrap' justify='space-between'>
            <InfoBadge>
              <Text>{extension}</Text>
            </InfoBadge>
            <InfoBadge style={{ textTransform: 'none' }}>
              <Text>{(size / 1000 / 1000).toFixed(2)} MB</Text>
            </InfoBadge>
            <IconButton
              disabled={isUploadPending}
              radius={36}
              w={40}
              p={0}
              icon={<TrashIcon />}
              onClick={onRemoveAsset}
            />
          </Group>
        </Group>
        {validationError}
      </Stack>
    </Card>
  );
}
